import { store } from '../../store'
import { httpgst } from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({ commit, dispatch }, payload) {
    let url = `api/comparative-reports/${payload.event.company_id}/${payload.event.item.type}`
    let params = {
      'specific': payload.event.item.specific,
      'year1': payload.event.item.year1,
      'month1': payload.event.item.month1,
      'quarter1': payload.event.item.quarter1,
      'year2': payload.event.item.year2,
      'month2': payload.event.item.month2,
      'quarter2': payload.event.item.quarter2
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params })
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getDownload ({ commit, dispatch }, payload) {
    let url = `api/comparative-reports/${payload.event.company_id}/${payload.event.item.type}`
    let params = {
      'specific': payload.event.item.specific,
      'year1': payload.event.item.year1,
      'month1': payload.event.item.month1,
      'quarter1': payload.event.item.quarter1,
      'year2': payload.event.item.year2,
      'month2': payload.event.item.month2,
      'quarter2': payload.event.item.quarter2,
      'download': 'download'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' })
      .then(
        response => {
          commit('onGetDownload', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let comparative = payload.response.data
    payload.event.context.comparative = comparative
    payload.event.context.type = payload.event.item.type
    payload.event.context.loading = false
    payload.event.context.loadingItems = true
    payload.event.context.organizeInformation()
    payload.event.context.close()
  },
  onGetDownload (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, `ExpensesComparative ${date}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportComparative.js